const resourcePickerReducers = {
  openReviewPicker: false,
};

function reducerActions(state, action) {
  if (typeof action.onSelected === "function") {
    state.onSelected = action.onSelected;
  }
  switch (action.type) {
    case "setOpenReviewPicker":
      if (state.actionResourceDataPickerReview)
        state.actionResourceDataPickerReview((v) => v + 1);
      state.openReviewPicker = action.payload;
      return state;
    case "onSelected":
      if (state.onSelected) state.onSelected(action.payload);
      return state;
    case "setActionResourceDataPickerReview":
      state.actionResourceDataPickerReview = action.payload;
      return state;
    default:
      return state;
  }
  // throw Error("Unknown action.");
}

export { reducerActions, resourcePickerReducers };
